module.exports = __webpack_public_path__ + "static/media/4-2.7e58fb42.mp3";